import { container } from 'tsyringe';
import { AuthService } from '@/core/auth/services/AuthService';

export const logoutUserUseCase = async (): Promise<void> => {
  const authService = container.resolve<AuthService>('MsalAuthService');
  await authService.logout();
};
